// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__38sSy","select":"Header_select__2NDLU","clinic":"Header_clinic__1uULQ"};